const QUESTION_LIKE_PREFIX =
  /^(como|qual|quais|o que|o quê|oq|onde|quando|por que|por quê|porque|quem)(?=\s|$)/i

export default function buildVariableSearchQuestion(rawSearch: string) {
  const search = rawSearch.trim().replace(/\s+/g, ' ')

  if (!search) {
    return ''
  }

  if (search.endsWith('?')) {
    return search
  }

  if (QUESTION_LIKE_PREFIX.test(search)) {
    return `${search}?`
  }

  return `Não encontrei uma variável pronta para "${search}". Que variável, indicador ou análise devo usar para investigar isso?`
}
